// import React, { useEffect } from "react";
// import { useForm } from "react-hook-form";
// import {  addWhareHouse, editWhareHouse } from "../../../services/MasterApiServices";
// import toast from "react-hot-toast";
// import { WhareHouseClass } from "../../../core/json/WhareHouseClass";
// import { useSelector } from "react-redux";

// const WhareHouseModal = ({ mode, data, handleClose, handleRefresh }) => {
//   const { register, handleSubmit, setValue, reset } = useForm({
//     mode: "onChange",
//     reValidateMode: "onChange",
//   });

//   // Get user from redux
//   const { userId } = useSelector((state) => state.userauth);

//   function resetmodal() {
//     if (mode === "edit" && data) {
//       setValue("name", data.name);
//       // Populate form with data for editing
//     } else {
//       reset();
//     }
//   }

//   useEffect(() => {
//     resetmodal();
//   }, [data, mode, setValue]);

//   // Handle form submission for adding or editing a unit
//   const handleFormSubmit = async (formData) => {
//     const objwharehouse = new WhareHouseClass();
//     objwharehouse.name = formData.name;
//     objwharehouse.description = formData.description;
//     objwharehouse.code = formData.code;
//     objwharehouse.vehicleNo = formData.vehicleNo;
//     objwharehouse.updatedUser = `{${userId?.id}}`; //"{9b57619d-63c8-4e27-9a59-639f0c80e4a1}";
//     if (mode === "edit") {
//       objwharehouse.guid = data.guid;
//       objwharehouse.id = data.id;
//     }

//     try {
//       const response =
//         mode === "edit" ? await editWhareHouse(objwharehouse) : await addWhareHouse(objwharehouse);

//       if (response.data==true) {
//         toast.success("Success");
//         handleRefresh(); // Refresh the list
//         handleClose(); // Close the modal
//       }else if(response.data==false){
//         toast.error("false")
//        }
//     } catch (error) {
//       toast.error(error?.response?.data?.Message || "something went wrong");
//       console.error(
//         "Error handling unit:",
//         error?.response?.data?.Message || "something went wrong"
//       );
//     }
//   };

//   return (
//     <div>
//       <div
//         className="modal fade show"
//         style={{ display: "block" }}
//         tabIndex="-1"
//       >
//         <div className="modal-dialog modal-dialog-centered custom-modal-two">
//           <div className="modal-content">
//             <div className="page-wrapper-new p-0">
//               <div className="content">
//                 <div className="modal-header border-0 custom-modal-header">
//                   <div className="page-title">
//                     <h4>{mode === "edit" ? "Edit Whare House" : "Add Whare House"}</h4>
//                   </div>
//                   <button
//                     type="button"
//                     className="close"
//                     aria-label="Close"
//                     onClick={handleClose}
//                   >
//                     <span aria-hidden="true">×</span>
//                   </button>
//                 </div>
//                 <div className="modal-body custom-modal-body">
//                   <form onSubmit={handleSubmit(handleFormSubmit)}>
//                     <div className="row">
//                          <div className="col-lg-12 col-md-12 col-sm-12">
//                         <div className="input-blocks">
//                           <label>
//                             Code 
//                           </label>
//                           <input
//                             type="text"
//                             placeholder="code"
//                             {...register("code")}
//                           />
//                         </div>
//                       </div>
//                       <div className="col-lg-12 col-md-12 col-sm-12">
//                         <div className="input-blocks">
//                           <label>
//                             Name <span className="text-danger">*</span>
//                           </label>
//                           <input
//                             type="text"
//                             placeholder="name"
//                             {...register("name")}
//                             required
//                           />
//                         </div>
//                       </div>
//                         <div className="col-lg-12 col-md-12 col-sm-12">
//                         <div className="input-blocks">
//                             <label>
//                             Description
//                             </label>
//                             <textarea
//                               className="form-control"
//                               rows="3"
//                               placeholder="Description"
//                               {...register("description")}
//                             ></textarea>
//                         </div>
//                       </div>
//                                <div className="col-lg-12 col-md-12 col-sm-12">
//                         <div className="input-blocks">
//                             <label>
//                                 Vehicle Number
//                             </label>
//                             <input
//                               type="text"
//                               placeholder="Vehicle Number"
//                               {...register("vehicleNo")}
//                             />
//                         </div>
//                                </div>
//                     </div>

//                     <div className="col-lg-12">
//                       <div className="modal-footer-btn">
//                         <button
//                           type="button"
//                           className="btn btn-cancel me-2"
//                           onClick={() => resetmodal()}
//                         >
//                           Reset
//                         </button>
//                         <button type="submit" className="btn btn-submit">
//                           {mode === "edit" ? "Save Changes" : "Save"}
//                         </button>
//                       </div>
//                     </div>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default WhareHouseModal ;

import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { addWareHouse, editWareHouse } from "../../../services/MasterApiServices";
import toast from "react-hot-toast";
import { WareHouseClass } from "../../../core/json/WareHouseClass";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { FormHint, FormPill } from "../ui/masterUi";

const WareHouseModal = ({ mode, data, handleClose, handleRefresh }) => {
  const { register, handleSubmit, setValue, reset, watch } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { userId } = useSelector((state) => state.userauth);
  const { branch } = useSelector((state) => state.branchlist);
  const { companyInfolist } = useSelector((state) => state.companyInfo);

  const [isVan, setIsVan] = useState(false); // 👈 state to control visibility

  // Reset modal data
  function resetmodal() {
    if (mode === "edit" && data) {
      setValue("name", data.name);
      setValue("description", data.description);
      setValue("code", data.code);
      setValue("vehicleNo", data.vehicleNo);
      setIsVan(data.isVAN || false);
    } else {
      reset();
      setIsVan(false);
    }
  }

  useEffect(() => {
    resetmodal();
  }, [data, mode]);

  // Submit handler
  const handleFormSubmit = async (formData) => {
    const objwarehouse = new WareHouseClass();

    objwarehouse.name = formData.name;
    objwarehouse.description = formData.description;
    objwarehouse.code = formData.code;
    objwarehouse.vehicleNo = isVan ? formData.vehicleNo : ""; // only if VAN
    objwarehouse.isVAN = isVan; // 👈 add to payload
//     objwarehouse.isVAN = isVan ? 1 : 0; // use 1/0 instead of true/false
// objwarehouse.vehicleNo = isVan ? formData.vehicleNo : null;

    // API-related fields
    objwarehouse.branchID = branch.guid || ""; // use branchId (not branchID)
    objwarehouse.companyID = companyInfolist?.[0]?.id || 0;
    objwarehouse.version = 1;
    objwarehouse.updatedUser = userId?.id ? `${userId.id}` : "";
    objwarehouse.updatedDate = dayjs().toISOString();

    if (mode === "edit") {
      objwarehouse.guid = data.guid;
      objwarehouse.id = data.id;
      objwarehouse.createdUser = data.createdUser || objwarehouse.updatedUser;
      objwarehouse.createdDate = data.createdDate || dayjs().toISOString();
    } else {
      objwarehouse.id = 0;
      objwarehouse.guid = crypto.randomUUID();
      objwarehouse.createdUser = userId?.id ? `${userId.id}` : "";
      objwarehouse.createdDate = dayjs().toISOString();
    }

    try {
      const response =
        mode === "edit"
          ? await editWareHouse(objwarehouse)
          : await addWareHouse(objwarehouse);

      if (response.data === true) {
        toast.success("Warehouse saved successfully!");
        handleRefresh();
        handleClose();
      } else {
        toast.error("Failed to save warehouse.");
      }
//       if (response.data === true) {
//   toast.success("Warehouse saved successfully!");
//   handleRefresh();
//   handleClose();
// } else {
//   // handle duplicate name/code case
//   if (formData.name && formData.code) {
//     toast.error("Warehouse with same name or code already exists.");
//   } else {
//     toast.error("Failed to save warehouse.");
//   }
// }

    } catch (error) {
      toast.error(error?.response?.data?.Message || "Something went wrong");
      console.error("Error saving warehouse:", error);
    }
  };

  return (
    <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>{mode === "edit" ? "Edit Warehouse" : "Add Warehouse"}</h4>
                </div>
                <FormPill mode={mode} />
                <button type="button" className="close" aria-label="Close" onClick={handleClose}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>

              <div className="modal-body custom-modal-body">
                <form onSubmit={handleSubmit(handleFormSubmit)}>
                  <div className="row">
                    {/* Code */}
                    <div className="col-lg-12 col-md-12">
                      <div className="input-blocks">
                        <label>Code</label>
                        <input type="text" placeholder="Code" {...register("code")} />
                      </div>
                    </div>

                    {/* Name */}
                    <div className="col-lg-12 col-md-12">
                      <div className="input-blocks">
                        <label>
                          Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Name"
                          {...register("name")}
                          required
                        />
                      </div>
                    </div>

                    {/* Description */}
                    <div className="col-lg-12 col-md-12">
                      <div className="input-blocks">
                        <label>Description</label>
                        <textarea
                          className="form-control"
                          rows="3"
                          placeholder="Description"
                          {...register("description")}
                        ></textarea>
                      </div>
                    </div>

                    {/* ✅ Is VAN Toggle */}
                    <div className="col-lg-12 col-md-12">
                      <div className="input-blocks d-flex align-items-center">
                        <label className="me-3">Is VAN</label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isVAN"
                            checked={isVan}
                            onChange={(e) => setIsVan(e.target.checked)}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ✅ Vehicle Number (only when isVan is true) */}
                    {isVan && (
                      <div className="col-lg-12 col-md-12">
                        <div className="input-blocks">
                          <label>Vehicle Number</label>
                          <input
                            type="text"
                            placeholder="Vehicle Number"
                            {...register("vehicleNo")}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="col-lg-12">
                    <div className="modal-footer-btn">
                      <FormHint />
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        onClick={() => resetmodal()}
                      >
                        Reset
                      </button>
                      <button type="submit" className="btn btn-submit">
                        {mode === "edit" ? "Save Changes" : "Save"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WareHouseModal;

